// For now, abilities are defined statically here:
export const NEW_CUSTOMER_DSA_ABILITIES = {
  // Hides Usage tab
  canEditUsage: false,

  // Does not allow activating Business Analytics area
  canActivateArea: area => area.title !== 'Business Analytics',
  canActivateBusinessAnalyticsArea: false,

  // Hides Analysis sections
  canViewOverviewAnalysis: false,
  canViewRecommendationOneAnalysis: false,
  canViewAdoptionAnalysis: false,
  canViewValueRealizedAnalysis: false,
  canViewOverlapAnalysis: false,
  canViewSecurityAnalysis: false,

  // Shows New Customer-specific Data Sources analysis section
  canViewDataSourcesAnalysis: true,

  canEditEstimatedLogSize: true,
  // Hides configured item form fields
  canEditPercentItemsIndexed: false,
  canEditPercentDataSourcesIndexed: false,
  canViewTotalIndexed: false,
  canEditPeakBuffer: false,

  // Hides ppt slides from output
  canViewRollUpOverviewSlide: true,
  canViewSecurityOverviewSlide: false,
  canViewSecurityDetailSlides: false,
  canViewSecurityDashboardSlides: false,
  canViewOverviewAreaSlides: false,
  canViewCurrentDeployment: false,

  canCalculateFullOverlap: false
};

export const FULL_DSA_ABILITIES = {
  canEditUsage: true,

  // Does not allow activating Business Analytics area
  canActivateArea: () => true,
  canActivateBusinessAnalyticsArea: true,

  canViewOverviewAnalysis: true,
  canViewRecommendationOneAnalysis: true,
  canViewAdoptionAnalysis: true,
  canViewValueRealizedAnalysis: true,
  canViewOverlapAnalysis: true,
  canViewSecurityAnalysis: true,

  // Hides New Customer-specific Data Sources analysis section
  canViewDataSourcesAnalysis: false,

  canEditEstimatedLogSize: true,
  canEditPercentItemsIndexed: true,
  canEditPercentDataSourcesIndexed: true,
  canViewTotalIndexed: true,
  canEditPeakBuffer: true,

  // Hides ppt slides from output
  canViewRollUpOverviewSlide: true,
  canViewSecurityOverviewSlide: true,
  canViewSecurityDetailSlides: true,
  canViewSecurityDashboardSlides: true,
  canViewOverviewAreaSlide: true,
  canViewCurrentDeployment: true,

  canCalculateFullOverlap: true
};

export const getAbilities = state => {
  if (state.dsa.dsa && state.dsa.dsa.dsaType === 'new-customer') {
    return NEW_CUSTOMER_DSA_ABILITIES;
  }

  return FULL_DSA_ABILITIES;
};



// WEBPACK FOOTER //
// ./src/selectors/dsa/abilitiesSelectors.js